module.exports = "<div class=\"c-auth c-auth--error\">\n    <div class=\"c-auth__inner\">\n        <div class=\"c-auth__content\">\n            <div class=\"c-auth__header u-fade-in\">\n                <logo-words></logo-words>\n            </div>\n\n            <div class=\"c-auth__message\">\n                <spinner large=\"true\"></spinner>\n                <h2>Loading...</h2>\n            </div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/auth/views/loading.html
// module id = 466
// module chunks = 0